// TSP map interaction hooks

import { useState } from 'react';

export const useMapPointSelect = () => {
  const [mapPointSelectCallback, setMapPointSelectCallback] = useState(null);
  
  // Set map point selection callback
  const setMapPointSelect = (callback) => {
    setMapPointSelectCallback(() => callback);
  };
  
  // Clear point selection callback
  const clearMapPointSelect = () => {
    setMapPointSelectCallback(null);
  };
  
  return {
    mapPointSelectCallback,
    setMapPointSelect,
    clearMapPointSelect
  };
};

export const isMapClickAddPointEnabled = (currentMode, setupSubmode) => {
  return currentMode === 'Setup Points' && setupSubmode === 'Map Points';
};

export const isPointSelectionEnabled = (currentMode) => {
  return currentMode === 'Custom Path';
}; 